import { useState } from "react";
import { motion, useMotionValueEvent, useScroll } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES, NAV_LINKS } from "@/data/content";

export const Logo = () => (
  <a href="#top" className="logo" data-testid="nav-logo" aria-label="AP Enterprises home">
    <img src={IMAGES.apeLogo} alt="APE logo" className="logo-img" />
    <span className="logo-text">
      AP <em>Enterprises</em>
    </span>
  </a>
);

export const Nav = () => {
  const { scrollY } = useScroll();
  const [scrolled, setScrolled] = useState(false);
  useMotionValueEvent(scrollY, "change", (v) => setScrolled(v > 60));

  return (
    <motion.header
      className={`nav ${scrolled ? "nav-scrolled" : ""}`}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
      data-testid="main-nav"
    >
      <Logo />
      <nav className="nav-links">
        {NAV_LINKS.map((l) => (
          <a key={l.href} href={l.href} className="nav-link" data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
            {l.label}
          </a>
        ))}
      </nav>
      <a href="#contact" className="nav-cta" data-testid="nav-contact-btn">
        Contact us <ArrowUpRight size={16} />
      </a>
    </motion.header>
  );
};
